import { render, staticRenderFns } from "./ProfileClicks.vue?vue&type=template&id=39063ab6&"
import script from "./ProfileClicks.vue?vue&type=script&lang=js&"
export * from "./ProfileClicks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports